import React from 'react';
import Icon from '../../../components/AppIcon';

const CoachingMethodology = () => {
  const methodologyPoints = [
    {
      icon: "Target",
      title: "Daily 5-10 Minute Drills",
      description: "Short, focused practice sessions that fit into your busy schedule. Consistency beats intensity every time.",
      color: "var(--color-primary)"
    },
    {
      icon: "TrendingUp",
      title: "AI-Powered Feedback",
      description: "Get instant analysis on clarity, confidence, control, and close. Learn what works and what needs improvement.",
      color: "var(--color-accent)"
    },
    {
      icon: "Shield",
      title: "Real-World Scenarios",
      description: "Practice handling objections, crafting scripts, and responding to situations you'll face in actual sales calls.",
      color: "var(--color-secondary)"
    },
    {
      icon: "Award",
      title: "Track Your Progress",
      description: "Build streaks, see your scores improve, and watch your skills grow with detailed performance metrics.",
      color: "var(--color-success)"
    }
  ];

  return (
    <div className="mb-12 px-4">
      <h2 className="text-2xl font-bold text-foreground text-center mb-8">
        How Lumo Coaching Works
      </h2>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-4xl mx-auto">
        {methodologyPoints?.map((point, index) => (
          <div
            key={index}
            className="bg-card rounded-2xl p-6 border border-border hover:shadow-card transition-all duration-300"
          >
            <div className="flex items-start gap-4">
              <div
                className="w-12 h-12 rounded-xl flex items-center justify-center flex-shrink-0"
                style={{ backgroundColor: `${point?.color}15` }}
              >
                <Icon name={point?.icon} size={24} color={point?.color} />
              </div>
              <div className="flex-1">
                <h3 className="text-lg font-semibold text-foreground mb-2">
                  {point?.title}
                </h3>
                <p className="text-sm text-muted-foreground leading-relaxed">
                  {point?.description}
                </p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CoachingMethodology;